"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Officer Jane Smith",
  quote: "Since partnering with St. Sampson Foundation, we've seen a significant decline in welfare checks and more engaged seniors.",
  position: "Local Police Department Officer",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590036/img/avatar_jane_smith.png",
  initials: "JS"
}, {
  author: "Mrs. Emily Johnson",
  quote: "The visitation program has brought so much joy and comfort to my mother. We are grateful for this ministry.",
  position: "Senior Caregiver and Family Member",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590036/img/avatar_emily_johnson.png",
  initials: "EJ"
}, {
  author: "Rev. Michael Thompson",
  quote: "This foundation exemplifies Christ’s love through service to the elderly. A true blessing to our community.",
  position: "Orthodox Priest",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590036/img/avatar_michael_thompson.png",
  initials: "MT"
}];
export default function VoicesOfTheCommunity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="voices-of-the-community" className="bg-background py-24 sm:py-32 overflow-hidden" ref={ref}>
      <div className={`container mx-auto px-4 md:px-6 max-w-6xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold tracking-widest uppercase text-secondary mb-3">
            Voices of the Community
          </h2>
          <div className="h-px w-12 bg-secondary mx-auto opacity-50"></div>
        </div>

        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full relative">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 md:px-20 lg:px-32 py-8">
                  <blockquote className="font-serif italic text-3xl md:text-4xl lg:text-5xl leading-tight text-primary mb-12 max-w-4xl mx-auto">
                    "{testimonial.quote}"
                  </blockquote>
                  
                  <div className="flex flex-col items-center gap-4">
                    <SafeHydrate><Avatar className="size-16 border border-border shadow-sm">
                      <AvatarImage src={testimonial.image} alt={testimonial.author} className="object-cover" />
                      <AvatarFallback className="bg-muted text-muted-foreground font-serif text-lg">
                        {testimonial.initials}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div>
                      <div className="font-semibold text-foreground text-base">
                        {testimonial.author}
                      </div>
                      <div className="text-sm text-muted-foreground mt-0.5">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <CarouselPrevious className="hidden md:flex absolute left-0 lg:-left-4 top-1/2 -translate-y-1/2 border-[0.5px] border-secondary text-secondary hover:bg-secondary/10 hover:text-secondary bg-transparent size-12 transition-colors" />
          <CarouselNext className="hidden md:flex absolute right-0 lg:-right-4 top-1/2 -translate-y-1/2 border-[0.5px] border-secondary text-secondary hover:bg-secondary/10 hover:text-secondary bg-transparent size-12 transition-colors" />
          
          {}
          <div className="flex items-center justify-center gap-6 mt-8 md:hidden">
            <CarouselPrevious className="static translate-y-0 translate-x-0 border-[0.5px] border-secondary text-secondary hover:bg-secondary/10 hover:text-secondary bg-transparent size-10" />
            <CarouselNext className="static translate-y-0 translate-x-0 border-[0.5px] border-secondary text-secondary hover:bg-secondary/10 hover:text-secondary bg-transparent size-10" />
          </div>
        </Carousel>
      </div>
    </section>;
}